import React from "react";
import { useTranslation } from "react-i18next";
import style from "../OrderInfoExpeditor.module.scss";
import CloseIcon from "../../../shared/icons/CloseIcon";
import CommentIcon from "../../../shared/icons/CommentIcon";
import OrderInfoExpeditorMoreMenu from "./OrderInfoExpeditorMoreMenu";
import AppTooltip from "../../../shared/AppTooltip/AppTooltip";
import { numberToFinanceFormat } from "../../../../utils";
import { CURRENCIES } from "../../../../mock";

const OrderInfoExpeditorHeader = ({
  item,
  setIsOpen,
  onOpenChat,
  unreadCount = 0,
  onForceUpdate,
  onRefreshOrder,
  isSummaryOnly = false,
}) => {
  const { t } = useTranslation();
  const routeTitle = item ? `${item.cityFromName || ""} - ${item.cityToName || ""}` : "";
  const subtitleMain = item ? `№ ${item.number}` : "";
  const currencySymbol = CURRENCIES[item?.currency || "KZT"]?.symbol || "";

  return (
    <div className={style.header}>
      <div className={style.header_left}>
        <CloseIcon
          fill="#6D7885"
          width="24"
          height="24"
          onClick={() => setIsOpen && setIsOpen(false)}
          style={{ cursor: "pointer", flexShrink: 0 }}
        />
        <div className={style.header_info}>
          <div className={style.header_title}>{routeTitle}</div>
          <div className={style.header_subtitle}>
            <span className={style.header_subtitle_main}>{subtitleMain}</span>
            {item?.senderCompanyName ? (
              <>
                <span
                  className={style.header_subtitle_main}
                  data-tooltip-id="expeditor-header-company-tooltip"
                >
                  {`• ${t("orderInfoExpeditor.header.partner")}:`}
                </span>
                <span
                  className={style.header_subtitle_expeditor}
                  data-tooltip-id="expeditor-header-company-tooltip"
                >
                  {item.senderCompanyName}
                </span>
                <AppTooltip
                  id="expeditor-header-company-tooltip"
                  positionStrategy="fixed"
                  delayShow={50}
                >
                  {item.senderCompanyName}
                </AppTooltip>
              </>
            ) : null}
          </div>
        </div>
        {!isSummaryOnly && item?.price ? (
          <div className={style.header_price}>
            <span className={style.header_currency}>{currencySymbol}</span>
            {numberToFinanceFormat(item.price, true)}
          </div>
        ) : null}
      </div>
      {!isSummaryOnly && (
        <div className={style.header_right}>
          <div className={style.header_chat_wrapper}>
            <button className={style.header_chat_btn} onClick={onOpenChat}>
              <CommentIcon width={20} height={20} fill="#0D3B66" type={2} />
              <span>{t("orderInfoExpeditor.header.chat")}</span>
            </button>
            {unreadCount > 0 && <div className={style.header_chat_badge}>{unreadCount}</div>}
          </div>
          <OrderInfoExpeditorMoreMenu item={item} onForceUpdate={onForceUpdate} onRefreshOrder={onRefreshOrder} setIsOpen={setIsOpen} />
        </div>
      )}
    </div>
  );
};

export default OrderInfoExpeditorHeader;
